import React from 'react';
import "./styles/Style.scss"
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from "./pages/home/HomePage";
import Layout from "./components/Layout";
import KurumsalPage from "./pages/kurumsal/KurumsalPage";
import ProgramPage from "./pages/programlar/ProgramPage";
import ObbTvHaberPage from "./pages/obbtvhaber/ObbTvHaberPage";
import YayinAkisiPage from "./pages/yayinakisi/YayinAkisiPage";
import CanliYayinPage from "./pages/canliyayin/CanliYayinPage";
import SehirKameralariPage from "./pages/sehirkameralari/SehirKameralariPage";
import { LoadingProvider } from './context/LoadingContext';
import {VideoContextProvider} from "./context/VideoContext";
import ProgramDetail from "./pages/programlar/ProgramDetail";

const App = () => {
    return (
        <VideoContextProvider>
            <LoadingProvider>
                <Router>
                    <Routes>
                        <Route element={<Layout/>}>
                            <Route path="/" element={<HomePage/>}/>
                            <Route path="/kurumsal" element={<KurumsalPage/>}/>
                            <Route path="/programlar/:programId" element={<ProgramDetail/>}/>
                            <Route path="/programlar" element={<ProgramPage/>}/>
                            <Route path="/obb-tv-haber" element={<ObbTvHaberPage/>}/>
                            <Route path="/yayin-akisi" element={<YayinAkisiPage/>}/>
                            <Route path="/canli-yayin" element={<CanliYayinPage/>}/>
                            <Route path="/sehir-kameralari" element={<SehirKameralariPage/>}/>
                        </Route>
                    </Routes>
                </Router>
            </LoadingProvider>
        </VideoContextProvider>

    )
}

export default App;
